/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpUtil from 'mbp-api-util';
import { configureHistory } from '../../../state/store';

const history = configureHistory();

const fiveORouteHistory = () => {
    let appRouterPrefix = '';
    const REACT_APP_INJECTABLE = mbpUtil.getEnv('REACT_APP_INJECTABLE');

    if (REACT_APP_INJECTABLE === 'false') {
        appRouterPrefix = '/z';
    }
    return {
        fiveOOoverride: {
            ...history,
            push: (path, state) => {
                if (typeof path === 'string') {
                    const prefixPath = path?.startsWith?.(appRouterPrefix) ? path : `${appRouterPrefix}${path}`;
                    if (history && history.location) {
                        // eslint-disable-next-line no-param-reassign
                        history.location.pathname = prefixPath;
                    }
                    history.push({
                        pathname: prefixPath,
                        state,
                    });
                } else if (path?.pathname) {
                    const { pathname, search, state: PathState } = path;
                    const prefixPath = pathname?.startsWith?.(appRouterPrefix) ? pathname : `${appRouterPrefix}${pathname}`;
                    if (history && history.location) {
                        // eslint-disable-next-line no-param-reassign
                        history.location.pathname = prefixPath;
                    }
                    history.push({
                        pathname: prefixPath,
                        state: PathState,
                        search,
                    });
                }
            },
            replace: (path, state) => {
                if (typeof path === 'string') {
                    const prefixPath = path?.startsWith?.(appRouterPrefix) ? path : `${appRouterPrefix}${path}`;
                    if (history && history.location) {
                        // eslint-disable-next-line no-param-reassign
                        history.location.pathname = prefixPath;
                    }
                    history.replace({
                        pathname: prefixPath,
                        state,
                    });
                } else if (path?.pathname) {
                    const { pathname, search, state: PathState } = path;
                    const prefixPath = pathname?.startsWith?.(appRouterPrefix) ? pathname : `${appRouterPrefix}${pathname}`;
                    if (history && history.location) {
                        // eslint-disable-next-line no-param-reassign
                        history.location.pathname = prefixPath;
                    }
                    history.replace({
                        pathname: prefixPath,
                        state: PathState,
                        search,
                    });
                }
            },
        },
        appRouterPrefix,
    };
};

export default fiveORouteHistory;
